/**
 * Minimal RFC-5545 .ics builder + browser download helper.
 * Used from student Home ("Add to calendar" icon per interview row) and
 * InterviewDetail (full "Add to calendar" button). No server round-trip;
 * everything computes from the interview payload the caller already has.
 */

export interface IcsEvent {
  scheduledAt: string;
  duration?: number;                // minutes, defaults to 40
  roundType?: string;
  room?: string;
  meetingLink?: string;
  partner?: { name?: string };
  title?: string;                   // overrides `${partner.name} — ${roundType}`
}

export function buildIcsFile(event: IcsEvent): string {
  const start = new Date(event.scheduledAt);
  const end = new Date(start.getTime() + (event.duration ?? 40) * 60_000);
  const fmt = (d: Date) => d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  const summary = event.title ?? `${event.partner?.name ?? 'Interview'} — ${event.roundType ?? 'Interview'}`;
  const location = event.meetingLink ?? event.room ?? '';
  return [
    'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Kollez//Interview//EN',
    'BEGIN:VEVENT',
    `UID:${start.getTime()}@kollez`,
    `DTSTAMP:${fmt(new Date())}`,
    `DTSTART:${fmt(start)}`,
    `DTEND:${fmt(end)}`,
    `SUMMARY:${summary.replace(/[\n,;]/g, ' ')}`,
    `LOCATION:${location.replace(/[\n,;]/g, ' ')}`,
    'END:VEVENT', 'END:VCALENDAR',
  ].join('\r\n');
}

export function downloadIcs(name: string, content: string): void {
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = name;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
